import {
   TRAINING_SESSION_PARTICIPANT_UPDATE
} from "./constants";
import moment from "moment-timezone";

export const updateTrainingSessionParticipant = (payload) => ({
   type: TRAINING_SESSION_PARTICIPANT_UPDATE.REQUEST,
   payload
});